import React from 'react';
import PropTypes from 'prop-types';

import ClaimsTableCell from './ClaimsTableCell';
import ClaimStatusBadge from '../../parcel-finder/ClaimStatusBadge/ClaimStatusBadge';
import ClaimsTypeBadge from './ClaimsTypeBadge';
import ClaimsValue from './ClaimsValue';
import Text from '../../common/Text/Text';

import './ClaimsTableRow.scss';
import ClaimsTableActionDropdownButton from './ClaimsTableActionDropdownButton';
import ClaimsTableSubmissionDate from './ClaimsTableSubmissionDate';
import DorStatusBadge from './DorStatusBadge';

function ClaimsTableRow({ claim, onTakeActionButtonClick, onCancelClaimButtonClick, onContinueClaimSubmission }) {
  const { status, claimType, netValueCurrency, netValue, trackingCode, dorStatus } = claim;

  return (
    <tr data-testid="claim-table-row">
      <ClaimsTableCell itemType="status">
        <ClaimStatusBadge status={status} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="type">
        <ClaimsTypeBadge claimType={claimType} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="value">
        <ClaimsValue currency={netValueCurrency} value={netValue} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="date">
        <ClaimsTableSubmissionDate claim={claim} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="code">
        <Text ink>{trackingCode}</Text>
      </ClaimsTableCell>
      <ClaimsTableCell itemType="dor-status">
        <DorStatusBadge dorStatus={dorStatus} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="action">
        <ClaimsTableActionDropdownButton
          claim={claim}
          onTakeActionButtonClick={onTakeActionButtonClick}
          onCancelClaimButtonClick={onCancelClaimButtonClick}
          onContinueClaimSubmission={onContinueClaimSubmission}
        />
      </ClaimsTableCell>
    </tr>
  );
}

ClaimsTableRow.propTypes = {
  claim: PropTypes.object,
  onTakeActionButtonClick: PropTypes.func,
  onCancelClaimButtonClick: PropTypes.func,
};

export default ClaimsTableRow;
